const convertEpochTimeToLocaleString = (timestamp) => {
    const asDate = new Date(timestamp);
    return asDate.toISOString();
};
export const reportIfTokenExpired = (accessToken, errorReporting) => {
    const payload = accessToken.split('.')[1];
    const parsedToken = JSON.parse(atob(payload));
    const expiry = parsedToken?.exp ? parsedToken.exp : undefined;
    const now = Date.now();
    if (expiry && expiry * 1000 <= now) {
        try {
            const message = `attempting to make request at ${convertEpochTimeToLocaleString(now)}, with invalid token expired at ${convertEpochTimeToLocaleString(expiry * 1000)}, token: ${accessToken}`;
            // eslint-disable-next-line no-console
            console.error(message);
            if (errorReporting) {
                const authError = new Error(message);
                authError.name = 'DashboardUserAuthExpiredToken';
                errorReporting.datadog.addError(authError);
            }
        }
        catch {
            // eslint-disable-next-line no-console
            console.error('could not send error report');
        }
    }
};
